import React from "react";

import {
  AiFillInstagram,
  AiOutlineTwitter,
  AiFillLinkedin,
  AiFillGithub,
} from "react-icons/ai";
import { MdEmail } from "react-icons/md";
const SocialLinks = () => {
  return (
    <>
      <a
        href="mailto:mdsaharshitol@gmail.com"
        className="mr-3 text-2xl icon-animate hover:text-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        <MdEmail />
      </a>
      <a
        href="https://github.com/mdsaharshital"
        className="mr-3 text-2xl icon-animate hover:text-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiFillGithub />
      </a>
      <a
        href="https://www.linkedin.com/in/mdshaharshitol/"
        className="mr-3 text-2xl icon-animate hover:text-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiFillLinkedin />
      </a>
      <a
        href="https://twitter.com/Md_Sahar_Shital"
        className="mr-3 text-2xl icon-animate hover:text-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiOutlineTwitter />
      </a>
      <a
        href="https://www.instagram.com/_shit_all_/"
        className="mr-3 text-2xl icon-animate hover:text-accent"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiFillInstagram />
      </a>
    </>
  );
};

export default SocialLinks;
